import { gsap } from 'gsap';
const id = 'backdrop'

$('body').append($(`
<div id="${id}"></div>
<style>
    #${id} {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        height: 100dvh;
        opacity: 0;
        visibility: hidden;
        background-color: rgba(0,0,0, 0.3);
        transition: opacity .1s, visibility .1s;
        z-index: 11;
    }
</style>
`));


const showBackdrop = function() {
    gsap.to(`#${id}`, {autoAlpha: 1, duration: .1});
}

const hideBackdrop = function() {
    gsap.to(`#${id}`, {autoAlpha: 0, duration: .1});
}

$(`#${id}`).on('click', function(){
  const $openCountrySwitcher = $('.lang-switcher__modal.open');

  if ($openCountrySwitcher.length) {
    $openCountrySwitcher.removeClass('open');
  }

  const $openLangSwitcher = $('.country-switcher__modal.open');
  if ($openLangSwitcher.length) {
    $openLangSwitcher.removeClass('open');
  }

  hideBackdrop();
});

export {
    showBackdrop,
    hideBackdrop
}
